// material-ui
import React from "react";
import { Stack, Grid, Typography } from "@mui/material";

// project imports
import LogoSection from "../LogoSection";
import { useDispatch, useSelector } from "store";
import { getPlayerBalance, getUsersByID } from "store/slices/user";

import useAuth from "hooks/useAuth";
import Iconify from "ui-component/iconify";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { playerBalance, singleUsers } = useSelector((state) => state.user);

  React.useEffect(() => {
    dispatch(getPlayerBalance(user));
    dispatch(getUsersByID(user));
  }, [dispatch, user]);

  return (
    <>
      <Grid
        container
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0px !important",
        }}
      >
        <Stack
          direction="row"
          spacing={0}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid sx={{ ml: 1, mt: 0 }}>
            <Stack direction="column" spacing={0.5}>
              <Stack
                direction="row"
                spacing={1}
                justifyContent="center"
                alignItems="center"
                sx={{
                  minWidth: 90,
                  height: 30,
                  pr: "8px",
                  pl: "8px",
                  borderRadius: "64px",
                  backgroundColor: "#fff",
                }}
              >
                <Iconify
                  width={"24px"}
                  height={"24px"}
                  icon="fluent-color:premium-16"
                />
                <Typography
                  variant="h4"
                  align="right"
                  type="number"
                  style={{ color: "#000" }}
                >
                  {parseInt(singleUsers[0]?.wheelPoint)} เพชร
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Stack>
        <LogoSection />
        <Stack
          direction="row"
          spacing={0}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid sx={{ mr: 1, mt: 0 }}>
            <Stack direction="column" spacing={0.5}>
              <Stack
                direction="row"
                spacing={1}
                justifyContent="center"
                alignItems="center"
                sx={{
                  minWidth: 90,
                  height: 30,
                  pr: "8px",
                  pl: "8px",
                  borderRadius: "64px",
                  backgroundColor: "#fff",
                }}
              >
                <Iconify width={"24px"} height={"24px"} icon="twemoji:coin" />

                <Typography
                  variant="h4"
                  align="right"
                  type="number"
                  style={{ color: "#000" }}
                >
                  {parseInt(playerBalance)} บาท
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Stack>
      </Grid>
    </>
  );
};

export default Header;
